/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { BillingModeEnum } from './billingModeEnum';


export interface BillingEventActionPayload { 
    /**
     * Name of S3 bucket from where to download billing usage files
     */
    bucket_name?: string;
    /**
     * Cloud Account Id which owns the S3 bucket
     */
    cloud_account_id?: string;
    edition?: string;
    mode?: BillingModeEnum;
    seller?: string;
    /**
     * Whether the S3 bucket is shared for the service across Orgs
     */
    shared_bucket: boolean;
    cloud_provider?: CloudProviderEnum;
}
export namespace BillingEventActionPayload {
}


